import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const MultipleLocationSearch = () => {
  const residentialOptionsMap = {
    Buy: [
      "All Residential",
      "2 BHK in Noida",
      "Villa in Pune",
      "3 BHK flat in Mumbai",
      "House in Hyderabad",
      "Flat in Bengaluru",
    ],
    Rent: ["Rent in Delhi", "PG in Indore", "Studio in Jaipur"],
  };

  const locationSuggestions = {
    "All Residential": [
      "Delhi",
      "Noida",
      "Indore",
      "Pune",
      "Mumbai",
      "Hyderabad",
      "Bengaluru",
      "Jaipur",
    ],
    "Rent in Delhi": ["Dwarka", "Saket", "Janakpuri"],
    "2 BHK in Noida": ["Sector 74", "Sector 137", "Sector 18"],
    "PG in Indore": ["Bhawarkua", "Palasia", "Scheme No. 54"],
    "Villa in Pune": ["Baner", "Hinjewadi", "Kharadi"],
    "3 BHK flat in Mumbai": ["Lokhandwala", "Bandra", "Andheri"],
    "House in Hyderabad": ["Gachibowli", "Miyapur", "Kukatpally"],
    "Flat in Bengaluru": ["Whitefield", "Koramangala", "HSR Layout"],
    "Studio in Jaipur": ["C-Scheme", "Malviya Nagar", "Vaishali Nagar"],
  };

  const [selectedTab, setSelectedTab] = useState("Buy");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedResidential, setSelectedResidential] =
    useState("All Residential");
  const [locations, setLocations] = useState(
    locationSuggestions["All Residential"]
  );
  const [results, setResults] = useState([]);

  useEffect(() => {
    const defaultOption = residentialOptionsMap[selectedTab]?.[0] || "";
    setSelectedResidential(defaultOption);
    setLocations(locationSuggestions[defaultOption] || []);
    setSearchQuery("");
    setResults([]);
  }, [selectedTab]);

  const handleTabClick = (tab) => setSelectedTab(tab);

  const handleResidentialChange = (e) => {
    const selected = e.target.value;
    setSelectedResidential(selected);
    setLocations(locationSuggestions[selected] || []);
    setSearchQuery("");
    setResults([]);
  };

  const handleTagClick = (location) => {
    const inIndex = selectedResidential.toLowerCase().indexOf(" in ");
    const type =
      inIndex !== -1
        ? selectedResidential.slice(0, inIndex)
        : selectedResidential;
    const newSearch = `${type} in ${location}`;
    setSearchQuery(newSearch);
    searchProperty(newSearch);
  };

  const handleSearch = () => {
    if (!searchQuery.trim()) {
      alert("Please enter or select a location to search.");
      return;
    }
    searchProperty(searchQuery);
  };

  const searchProperty = async (query) => {
    const typeMatch = query.match(/^(.*?) in /i);
    const locationMatch = query.match(/ in (.*)$/i);
    const type = typeMatch ? typeMatch[1] : "";
    const location = locationMatch ? locationMatch[1] : "";

    try {
      const res = await fetch(
        `http://localhost:3002/api/properties/search?type=${type}&location=${location}&category=${selectedTab}`
      );
      const data = await res.json();
      setResults(data);
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      style={styles.wrapper}
    >
      <div style={styles.tabWrapper}>
        {["Buy", "Rent", "New Launch", "Commercial", "Plots/Land", "Projects"].map(
          (tab) => (
            <motion.div
              key={tab}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleTabClick(tab)}
              style={{
                ...styles.tab,
                ...(tab === selectedTab && styles.activeTab),
              }}
            >
              {tab}
            </motion.div>
          )
        )}
        <div style={styles.postProperty}>
          Post Property <span style={{ color: "green" }}>FREE</span>
        </div>
      </div>

      <div style={styles.searchBar}>
        {residentialOptionsMap[selectedTab] && (
          <select
            style={styles.select}
            onChange={handleResidentialChange}
            value={selectedResidential}
          >
            {residentialOptionsMap[selectedTab].map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        )}
        <input
          type="text"
          placeholder='e.g. "Villa in Baner Pune"'
          style={styles.input}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <motion.button
          style={styles.searchBtn}
          onClick={handleSearch}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Search
        </motion.button>
      </div>

      {locations.length > 0 && (
        <div style={styles.recent}>
          <span style={{ fontWeight: 600, marginRight: 10 }}>Suggested:</span>
          <div style={styles.tagList}>
            {locations.map((loc, i) => (
              <motion.div
                key={i}
                style={styles.tag}
                onClick={() => handleTagClick(loc)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                📍 {loc}
              </motion.div>
            ))}
          </div>
        </div>
      )}

      {results.length > 0 ? (
        <div style={styles.cardGrid}>
          {results.map((item) => (
            <motion.div
              key={item.id}
              style={styles.card}
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={styles.cardImage}
              />
              <div style={styles.cardBody}>
                <h4>{item.title}</h4>
                <p>{item.location}</p>
                <strong>{item.price}</strong>
              </div>
            </motion.div>
          ))}
        </div>
      ) : (
        <p style={{ marginTop: 20, fontWeight: 500 }}>
          No results found. Try different keywords or category.
        </p>
      )}
    </motion.div>
  );
};

// 🎨 Watercolor-style visual design
const styles = {
  wrapper: {
    marginTop: "100px",
    background: "rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(10px)",
    padding: "30px 25px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    borderRadius: "20px",
    maxWidth: "1000px",
    marginLeft: "auto",
    marginRight: "auto",
    width: "90%",
    border: "1px solid rgba(255, 255, 255, 0.3)",
  },
  tabWrapper: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
    alignItems: "center",
    marginBottom: "20px",
  },
  tab: {
    fontWeight: 500,
    color: "#3b3b3b",
    cursor: "pointer",
    padding: "6px 12px",
    borderRadius: "8px",
    backgroundColor: "rgba(173, 216, 230, 0.2)",
    transition: "all 0.3s ease",
  },
  activeTab: {
    color: "#0066cc",
    backgroundColor: "rgba(0, 102, 204, 0.15)",
    border: "1px solid #0077cc",
    fontWeight: 600,
  },
  postProperty: {
    marginLeft: "auto",
    fontWeight: 600,
    cursor: "pointer",
    color: "#4caf50",
    backgroundColor: "rgba(76, 175, 80, 0.1)",
    padding: "6px 12px",
    borderRadius: "8px",
  },
  searchBar: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: "20px",
  },
  select: {
    padding: "10px 14px",
    borderRadius: "12px",
    border: "1px solid #cce0ff",
    fontSize: "14px",
    minWidth: "200px",
    backgroundColor: "rgba(240, 248, 255, 0.8)",
  },
  input: {
    flex: 1,
    padding: "10px 14px",
    borderRadius: "12px",
    border: "1px solid #cce0ff",
    fontSize: "14px",
    minWidth: "200px",
    backgroundColor: "rgba(240, 248, 255, 0.8)",
  },
  searchBtn: {
    padding: "10px 18px",
    backgroundColor: "#6bb1ff",
    color: "#fff",
    borderRadius: "12px",
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(107, 177, 255, 0.3)",
  },
  recent: {
    marginTop: 10,
  },
  tagList: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "10px",
  },
  tag: {
    backgroundColor: "#e3f2fd",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "13px",
    color: "#007aff",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    marginTop: "30px",
  },
  card: {
    border: "1px solid #f0f0f0",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
    transition: "all 0.3s ease-in-out",
  },
  cardImage: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
  },
  cardBody: {
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
};

export default MultipleLocationSearch;
